import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { useState } from 'react';
import { Form, FormControlProps, FormGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

export type DateInputProps = FormControlProps & {
  label?: string | JSX.Element;
  placeholder?: string;
  initialDate?: Date;
  icon?: IconProp;
  onChange?: (date: any) => void;
  minDate?: Date;
  maxDate?: Date;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
  maxWidth?: string;
};

const DatePickerInput: React.FC<DateInputProps> = ({
  label,
  placeholder,
  disabled,
  onChange,
  isValid,
  icon = light('calendar'),
  isInvalid,
  className,
  initialDate,
  minDate,
  maxDate,
  showMonthDropdown = true,
  showYearDropdown = true,
  maxWidth = '100%',
  ...props
}) => {
  const setIcon = (iconName: IconProp) => (
    <FontAwesomeIcon icon={iconName} className={`icon icon--right`} />
  );

  const [startDate, setStartDate] = useState(initialDate ? initialDate : null);

  const handleDateChange = (date: Date) => {
    setStartDate(date);
    onChange && onChange(date);
  };

  return (
    <FormGroup
      className={`${className ? className : ''} date-picker-custom`}
      {...props}
    >
      {label && <Form.Label>{label}</Form.Label>}
      <div style={{ maxWidth: maxWidth }} className="input-wrapper">
        {icon && setIcon(icon)}
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          placeholderText={placeholder}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className={`form-control ${isValid && 'is-valid'} ${
            isInvalid && 'is-invalid'
          }`}
          calendarClassName={'cnd-calendar'}
        />
      </div>
    </FormGroup>
  );
};

export default DatePickerInput;
